module.exports = __webpack_public_path__ + "static/media/drpic1.4011bb3c.png";